import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactTouch extends EventRegistryCategory {
    label = 'Touch Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    touchcancel = () => new EventRegistryItem({ handlerName: 'onTouchCancel' });
    touchend = () => new EventRegistryItem({ handlerName: 'onTouchEnd' });
    touchmove = () => new EventRegistryItem({ handlerName: 'onTouchMove' });
    touchstart = () => new EventRegistryItem({ handlerName: 'onTouchStart' });
}
